import { theme } from '@revenuemarket/design';

interface Props {
  width?: number;
  height?: number;
  color?: string;
}

export const Flare = ({
  width = 16,
  height = 16,
  color = theme.colorTokens.iconWarning,
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1773_343413"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1773_343413)">
        <path
          d="M0.666626 8.66675V7.33342H4.66663V8.66675H0.666626ZM5.16663 6.10008L3.76663 4.70008L4.69996 3.76675L6.09996 5.16675L5.16663 6.10008ZM7.33329 4.66675V0.666748H8.66663V4.66675H7.33329ZM10.8333 6.10008L9.89996 5.16675L11.3 3.76675L12.2333 4.70008L10.8333 6.10008ZM11.3333 8.66675V7.33342H15.3333V8.66675H11.3333ZM7.99996 10.0001C7.4444 10.0001 6.97218 9.80564 6.58329 9.41675C6.1944 9.02786 5.99996 8.55564 5.99996 8.00008C5.99996 7.44453 6.1944 6.9723 6.58329 6.58342C6.97218 6.19453 7.4444 6.00008 7.99996 6.00008C8.55552 6.00008 9.02774 6.19453 9.41663 6.58342C9.80552 6.9723 9.99996 7.44453 9.99996 8.00008C9.99996 8.55564 9.80552 9.02786 9.41663 9.41675C9.02774 9.80564 8.55552 10.0001 7.99996 10.0001ZM11.3 12.2334L9.89996 10.8334L10.8333 9.90008L12.2333 11.3001L11.3 12.2334ZM4.69996 12.2334L3.76663 11.3001L5.16663 9.90008L6.09996 10.8334L4.69996 12.2334ZM7.33329 15.3334V11.3334H8.66663V15.3334H7.33329Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
